import type { Custodian } from 'models/custodian';
import type { LoadingResult } from 'models/forms/TradeAllocationFormResult';
import { connect } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { TradeAllocationRowModel } from 'state/tradeAllocationForm';
import {
  tradeAllocationRowChanged,
  tradeAllocationRowRemoved,
} from 'state/tradeAllocationForm/tradeAllocationForm.actions';
import * as tradeAllocationSelector from 'state/tradeAllocationForm/tradeAllocationForm.selector';

interface OwnProps {
  tabId: string;
  preComPrice?: number;
  offerPriceUnit?: string;
}

interface StateProps {
  allocations: TradeAllocationRowModel[];
  custodians: LoadingResult<ReadonlyArray<Custodian>>;
  currency: string;
  unallocatedNotional: number;
  hasIndependentAmount: boolean;
  isReadOnly: boolean;
  isLoading: boolean;
}

interface DispatchProps {
  onAllocationChanged: (index: number, allocation: TradeAllocationRowModel) => void;
  onAllocationRemoved: (index: number) => void;
}

export type TradeAllocationProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    allocations: tradeAllocationSelector.getAllocationDetails(state, tabId)!,
    custodians: tradeAllocationSelector.getCustodians(state, tabId)!,
    currency: tradeAllocationSelector.getCurrency(state, tabId)!,
    unallocatedNotional: tradeAllocationSelector.getUnallocatedNotional(state, tabId)!,
    isReadOnly: tradeAllocationSelector.isReadonly(state, tabId)!,
    isLoading: tradeAllocationSelector.isLoading(state, tabId),
    hasIndependentAmount: tradeAllocationSelector.getIsOtc(state, tabId),
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => ({
  onAllocationChanged(index, allocation) {
    dispatch(tradeAllocationRowChanged(tabId, index, allocation));
  },
  onAllocationRemoved(index) {
    dispatch(tradeAllocationRowRemoved(tabId, index));
  },
});

export const connectTradeAllocation = connect(mapStateToProps, mapDispatchToProps);
